export default "__VITE_ASSET__CA4_5qoK__"